type MerchandisableQuantityRange = {
  increment: number;
  maximum: number;
  minimum: number;
};
type MerchandisableQuantitiesType = {
  list?: number[];
  range?: MerchandisableQuantityRange[];
};

// don't generate quantity ranges of more than 1000
// ran into an item (2 oz. Hand Sanitizer Gel Bottle) that had a range of
// { minimum: 125, maximum: 100000, increment: 1 } which generates 99876 items
const MAX_ITEMS = 1000;

export const getQuantitySelectionValues = ({
  activeQuantity,
  merchandisableQuantities,
}: {
  activeQuantity: string | number;
  merchandisableQuantities?: MerchandisableQuantitiesType;
}) => {
  if (!merchandisableQuantities) {
    return null;
  }

  let quantities: number[] = [];

  // item has a list of quanity values, add them to the selectable values
  if (
    merchandisableQuantities.list &&
    merchandisableQuantities.list.length > 0
  ) {
    quantities = quantities.concat(merchandisableQuantities.list);
  }

  // if the item has a range (or ranges), calculate the values and add them to the selectable values
  if (
    merchandisableQuantities.range &&
    merchandisableQuantities.range.length > 0
  ) {
    const rangeQuantity = merchandisableQuantities.range.map(
      (range: MerchandisableQuantityRange) => {
        const { minimum, maximum, increment } = range;

        return Array.from(
          { length: Math.min(maximum - minimum, MAX_ITEMS) / increment + 1 },
          (value, index) => minimum + index * increment
        );
      }
    );

    quantities = quantities.concat(rangeQuantity.flat());
  }

  // If the current line item quantity is not included in the array of merchandisable quantities, then add it
  const parsedActiveQuantity =
    typeof activeQuantity === 'number'
      ? activeQuantity // no need to parseInt a number
      : parseInt(activeQuantity, 10);

  if (Number.isNaN(parsedActiveQuantity) === false) {
    if (!quantities.includes(parsedActiveQuantity)) {
      quantities.push(parsedActiveQuantity);
    }
  }

  // make sure values are unique, sort the values and return
  const uniq = Array.from(new Set(quantities));
  return uniq.sort((a: number, b: number) => a - b);
};
